export default __webpack_public_path__ + "static/media/profile.f33a5edf.png";